{********************************************************************}
{                                                                    }
{ written by TMS Software                                            }
{            copyright (c) 2018                                      }
{            Email : info@tmssoftware.com                            }
{            Web : http://www.tmssoftware.com                        }
{                                                                    }
{ The source code is given as is. The author is not responsible      }
{ for any possible damage done due to the use of this code.          }
{ The complete source code remains property of the author and may    }
{ not be distributed, published, given or sold in any form as such.  }
{ No parts of the source code can be included in any other component }
{ or application without written authorization of the author.        }
{********************************************************************}

unit WEBLib.TMSFNCWidgetGraphicsTypes;

interface

uses Classes, WEBLib.TMSFNCGraphicsTypes;

type
  TTMSFNCWidgetGraphicsFill = class(TTMSFNCCustomGraphicsFill)
  public
    constructor Create(const AKind: TTMSFNCGraphicsFillKind = gfkSolid; const AColor: TTMSFNCGraphicsColor = gcWhite; const AColorTo: TTMSFNCGraphicsColor = gcGray; const AColorMirror: TTMSFNCGraphicsColor = gcNull; const AColorMirrorTo: TTMSFNCGraphicsColor = gcNull); override;
  published
    property OnChanged;
    property Kind nodefault;
    property Orientation nodefault;
    property Color nodefault;
    property ColorTo nodefault;
    property ColorMirror nodefault;
    property ColorMirrorTo nodefault;
    property Texture;
    property TextureMode nodefault;
  end;

  TTMSFNCWidgetGraphicsStroke = class(TTMSFNCCustomGraphicsStroke)
  public
    constructor Create(const AKind: TTMSFNCGraphicsStrokeKind = gskSolid; const AColor: TTMSFNCGraphicsColor = gcSilver; const AWidth: Single = 0.0); override;
  published
    property OnChanged;
    property Kind nodefault;
    property Color nodefault;
    property Width;
  end;

implementation

constructor TTMSFNCWidgetGraphicsFill.Create(const AKind: TTMSFNCGraphicsFillKind = gfkSolid; const AColor: TTMSFNCGraphicsColor = gcWhite; const AColorTo: TTMSFNCGraphicsColor = gcGray; const AColorMirror: TTMSFNCGraphicsColor = gcNull; const AColorMirrorTo: TTMSFNCGraphicsColor = gcNull);
begin
  inherited;

  Kind := AKind;
  Orientation :=gfoVertical;
  Color := AColor;
  ColorTo :=  gcGray;
  ColorMirror :=  gcNull;
  ColorMirrorTo :=  gcNull;
  TextureMode := gtmStretch;
end;

constructor TTMSFNCWidgetGraphicsStroke.Create(const AKind: TTMSFNCGraphicsStrokeKind = gskSolid; const AColor: TTMSFNCGraphicsColor = gcSilver; const AWidth: Single = 0.0);
begin
  inherited;
  Width := AWidth;
  Kind := AKind;
  Color := AColor;
end;


end.
